// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.expand-enter-active,\n  .expand-leave-active {\n    transition-property: opacity, height;\n    transition: height 0.2s ease-in;\n    overflow: hidden;\n}\n.expand-enter-from,\n  .expand-leave-to {\n    /*height: 0;*/\n    opacity: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
